import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Location } from '@angular/common';
import { UserManagementComponent } from '@luzula/luzula-lib';
import { Command, NavbarService } from '../navbar.service';

/**
 * Wrapper um die Library-Benutzerverwaltung als Master-Detail-Seite
 * ({@link UserManagementComponent}: Benutzer + Gruppen auf EINER Seite). Aktiviert
 * in der Navbar den Zurück-Befehl, damit der User die Seite über die globale
 * Toolbar wieder verlassen kann — analog zum Punkt-Editor-Pattern.
 *
 * Die Datenbankverwaltung ist bewusst NICHT mehr hier eingebunden (fruehe:
 * entwickler-gated Tab): sie ist seit 2026-08-03 ein eigener top-level Menüpunkt
 * (`admin/databases` → {@link DbAdminPageComponent}), nur für Entwickler.
 *
 * Die Library bleibt navbar-frei: dieser Wrapper ist app-spezifisch und
 * kennt das Command-Bus-System von bpweb.
 */
@Component({
	selector: 'bp-users-page',
	standalone: true,
	imports: [UserManagementComponent],
	// Viewport-basierte feste Hoehe (bpweb-Muster, analog bp-db-admin-page): height:100%
	// greift hier NICHT (html/body-Kette gibt keine feste Hoehe her) -> sonst scrollt die
	// ganze Seite inkl. Navbar. Mit fester Hoehe scrollt nur die Nutzerliste intern.
	template: '<lz-user-management></lz-user-management>',
	styles: [':host { display: block; height: calc(var(--vh, 100vh) - var(--navbar-height, 0px)); overflow-y: auto; }'],
})
export class UsersPageComponent implements OnInit, OnDestroy {
	private navbar = inject(NavbarService);
	private location = inject(Location);

	ngOnInit(): void {
		this.navbar.subscribe(Command.goBack, () => this.location.back());
	}

	ngOnDestroy(): void {
		this.navbar.unsubscribe(Command.goBack);
	}
}
